var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "vks-genes-drawer" },
    [
      _c("p", { staticClass: "vks-ui-intro" }, [
        _vm._v(
          " Choose which gene biotypes appear on the genes track for this locus. "
        ),
      ]),
      _vm.loading
        ? _c("div", { staticClass: "vks-ui-status" }, [
            _vm._v("Loading genes…"),
          ])
        : _vm.error
        ? _c("div", { staticClass: "vks-ui-error", attrs: { role: "alert" } }, [
            _vm._v(" " + _vm._s(_vm.error) + " "),
          ])
        : !_vm.geneTypeOptions.length
        ? [
            _c("p", { staticClass: "vks-ui-hint" }, [
              _vm._v("No gene biotypes are available for this locus."),
            ]),
          ]
        : [
            _c("div", { staticClass: "vks-genes-select-row" }, [
              _c(
                "label",
                {
                  staticClass: "vks-genes-select-label",
                  attrs: { for: _vm.geneTypesSelectId },
                },
                [_vm._v(" Gene types in this locus ")]
              ),
              _c(
                "select",
                {
                  key: _vm.selectedTypesKey,
                  staticClass: "custom-select vks-genes-select",
                  attrs: {
                    id: _vm.geneTypesSelectId,
                    multiple: "",
                    size: _vm.selectSize,
                  },
                  on: { change: _vm.onTypesChange },
                },
                _vm._l(_vm.geneTypeOptions, function (geneType) {
                  return _c(
                    "option",
                    {
                      key: geneType,
                      domProps: {
                        value: geneType,
                        selected: _vm.selectedTypes.includes(geneType),
                      },
                    },
                    [
                      _vm._v(
                        " " + _vm._s(_vm.formatGeneTypeLabel(geneType)) + " "
                      ),
                    ]
                  )
                }),
                0
              ),
              _c("p", { staticClass: "vks-ui-hint" }, [
                _vm._v(
                  " Hold " +
                    _vm._s(_vm.modifierLabel) +
                    " to select multiple types. Default is coding genes only. "
                ),
              ]),
              _c("div", { staticClass: "vks-ui-btn-row" }, [
                _c(
                  "button",
                  {
                    staticClass: "vks-ui-btn vks-ui-btn--secondary",
                    attrs: { type: "button" },
                    on: { click: _vm.selectCodingOnly },
                  },
                  [_vm._v(" Coding only ")]
                ),
                _c(
                  "button",
                  {
                    staticClass: "vks-ui-btn vks-ui-btn--secondary",
                    attrs: { type: "button" },
                    on: { click: _vm.selectAllTypes },
                  },
                  [_vm._v(" All types ")]
                ),
              ]),
            ]),
            _c("div", { staticClass: "vks-genes-legend" }, [
              _c("p", { staticClass: "vks-ui-section-title" }, [
                _vm._v("Color key"),
              ]),
              _c(
                "ul",
                { staticClass: "vks-genes-legend-list" },
                _vm._l(_vm.geneTypeOptions, function (geneType) {
                  return _c(
                    "li",
                    { key: geneType, staticClass: "vks-genes-legend-item" },
                    [
                      _c("span", {
                        staticClass: "vks-genes-legend-swatch",
                        style: {
                          backgroundColor: _vm.geneTypeColors[geneType],
                        },
                        attrs: { "aria-hidden": "true" },
                      }),
                      _c("span", [
                        _vm._v(_vm._s(_vm.formatGeneTypeLabel(geneType))),
                      ]),
                    ]
                  )
                }),
                0
              ),
            ]),
            _c("p", { staticClass: "vks-ui-status" }, [
              _vm._v(
                " Showing " +
                  _vm._s(_vm.visibleGeneCount.toLocaleString()) +
                  " of " +
                  _vm._s(_vm.totalGeneCount.toLocaleString()) +
                  " genes in this locus. "
              ),
            ]),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }